import { orderSecondaryStage, orderStage } from 'common/constants/booking';

const processStatus = {
  TODO: 'todo',
  DOING: 'doing',
  DONE: 'done',
  FAILED: 'failed',
};

const processStepEnum = {
  CREATE_BOOKING: 'create',
  BOOKING_CONFIRMATION: 'confirmation',
  RESELECTING_PAYMENT_PLAN: 'reselecting_payment_plan',
  PENDING_PAYMENT: 'payment',
  MOVE_IN: 'check_in',
  COMPLETED: 'completed',
};

const handleWaitingForConfirmation = (currentProcess, processStep, processes) => {
  const PROCESS_LENGTH = processes.length;
  Object.assign(processStep, {
    [processStepEnum.CREATE_BOOKING]: {
      ...currentProcess,
      ...processStep[processStepEnum.CREATE_BOOKING],
      status: processStatus.DONE,
    },
  });

  // 创建和确认订单的currentStage都为WAITING_FOR_CONFIRMATION，所以需要根据processes的长度进行分别判断
  // 订单创建
  if (PROCESS_LENGTH === 1) {
    Object.assign(processStep, {
      [processStepEnum.BOOKING_CONFIRMATION]: {
        ...currentProcess,
        ...processStep[processStepEnum.BOOKING_CONFIRMATION],
        status: processStatus.DOING,
        countdown: {
          initTime: processes[0]?.updatedAt,
        },
      },
    });
  } else if ([orderStage.LOST, orderStage.CANCELLED].includes(processes[1]?.currentStage)) {
    // 订单确认失败
    Object.assign(processStep, {
      [processStepEnum.BOOKING_CONFIRMATION]: {
        ...processes[1],
        ...processStep[processStepEnum.BOOKING_CONFIRMATION],
        status: processStatus.FAILED,
      },
    });
  } else {
    // 订单已确认
    Object.assign(processStep, {
      [processStepEnum.BOOKING_CONFIRMATION]: {
        ...currentProcess,
        ...processStep[processStepEnum.BOOKING_CONFIRMATION],
        status: processStatus.DONE,
      },
    });
  }
};

const handleWaitingForPayment = (
  currentProcess,
  processStep,
  processes,
  needReselectPaymentPlan,
  nextIndex,
  preIndex,
) => {
  const PROCESS_LENGTH = processes.length;
  const lastProcess = processes[PROCESS_LENGTH - 1].currentStage;
  const isActiveProcess = currentProcess.currentStage === lastProcess;
  if (!needReselectPaymentPlan) {
    delete processStep.reselecting_payment_plan;
  } else if (
    nextIndex <= PROCESS_LENGTH - 1 &&
    [orderStage.LOST, orderStage.CANCELLED].includes(processes[nextIndex].currentStage)
  ) {
    Object.assign(processStep, {
      [processStepEnum.RESELECTING_PAYMENT_PLAN]: {
        ...processes[nextIndex],
        ...processStep[processStepEnum.RESELECTING_PAYMENT_PLAN],
        status: processStatus.FAILED,
      },
    });
  } else if (isActiveProcess) {
    Object.assign(processStep, {
      [processStepEnum.RESELECTING_PAYMENT_PLAN]: {
        ...currentProcess,
        ...processStep[processStepEnum.RESELECTING_PAYMENT_PLAN],
        status: processStatus.DOING,
        countdown: {
          initTime: processes[preIndex]?.updatedAt,
        },
      },
    });
  } else {
    Object.assign(processStep, {
      [processStepEnum.RESELECTING_PAYMENT_PLAN]: {
        ...currentProcess,
        ...processStep[processStepEnum.RESELECTING_PAYMENT_PLAN],
        status: processStatus.DONE,
      },
    });
  }
};

const handleWaitingForCheckIn = (
  currentProcess,
  processStep,
  processes,
  nextIndex,
  preIndex,
  paymentParam,
  landlordConfirmedPayment,
  noInstalmentType,
) => {
  const PROCESS_LENGTH = processes.length;
  const isActiveProcess =
    currentProcess.currentStage === processes[PROCESS_LENGTH - 1].currentStage;
  if (
    nextIndex <= PROCESS_LENGTH - 1 &&
    [orderStage.LOST, orderStage.CANCELLED].includes(processes[nextIndex].currentStage)
  ) {
    Object.assign(processStep, {
      [processStepEnum.PENDING_PAYMENT]: {
        ...processes[nextIndex],
        ...processStep[processStepEnum.PENDING_PAYMENT],
        status: processStatus.FAILED,
      },
    });
  } else if (isActiveProcess && landlordConfirmedPayment) {
    // 已支付
    Object.assign(processStep, {
      [processStepEnum.PENDING_PAYMENT]: {
        ...paymentParam,
        ...processStep[processStepEnum.PENDING_PAYMENT],
        status: processStatus.DONE,
      },
    });
  } else if (isActiveProcess && !landlordConfirmedPayment) {
    // 未支付且没有payment plan，需要重新选择payment plan
    if (noInstalmentType) {
      Object.assign(processStep, {
        [processStepEnum.RESELECTING_PAYMENT_PLAN]: {
          ...currentProcess,
          ...processStep[processStepEnum.RESELECTING_PAYMENT_PLAN],
          status: processStatus.DOING,
          countdown: {
            initTime: processes[preIndex]?.updatedAt,
          },
        },
      });
    } else {
      Object.assign(processStep, {
        [processStepEnum.PENDING_PAYMENT]: {
          ...paymentParam,
          ...processStep[processStepEnum.PENDING_PAYMENT],
          status: processStatus.DOING,
        },
      });
    }
  } else {
    Object.assign(processStep, {
      [processStepEnum.PENDING_PAYMENT]: {
        ...paymentParam,
        ...processStep[processStepEnum.PENDING_PAYMENT],
        status: processStatus.DONE,
      },
    });
  }
};

const handleCheckedIn = (currentProcess, processStep, processes, nextIndex) => {
  const PROCESS_LENGTH = processes.length;
  const isActiveProcess =
    currentProcess.currentStage === processes[PROCESS_LENGTH - 1].currentStage;
  if (
    nextIndex <= PROCESS_LENGTH - 1 &&
    [orderStage.LOST, orderStage.CANCELLED].includes(processes[nextIndex].currentStage)
  ) {
    Object.assign(processStep, {
      [processStepEnum.MOVE_IN]: {
        ...processes[nextIndex],
        ...processStep[processStepEnum.MOVE_IN],
        status: processStatus.FAILED,
      },
    });
  } else if (isActiveProcess) {
    Object.assign(processStep, {
      [processStepEnum.MOVE_IN]: {
        ...currentProcess,
        ...processStep[processStepEnum.MOVE_IN],
        status: processStatus.DOING,
      },
    });
  } else {
    Object.assign(processStep, {
      [processStepEnum.MOVE_IN]: {
        ...currentProcess,
        ...processStep[processStepEnum.MOVE_IN],
        status: processStatus.DONE,
      },
    });
  }
};

const handleCompleted = (currentProcess, processStep) => {
  return (processStep[processStepEnum.COMPLETED] = {
    ...processStep[processStepEnum.COMPLETED],
    ...currentProcess,
    status: processStatus.DONE,
  });
};

const formatProcessStep = order => {
  const processes = order?.processes ?? [];
  const noInstalmentType = !order.instalmentPlanType;
  const needReselectPaymentPlan =
    processes.filter(
      item =>
        item?.currentStage === orderStage.WAITING_FOR_PAYMENT &&
        item?.currentSecondaryStage === orderSecondaryStage.COUNTER_OFFER_ACCEPTED_BY_STUDENT,
    ).length > 0;

  const processStep = {
    [processStepEnum.CREATE_BOOKING]: {
      iconHash: 'progress-application-form',
      status: processStatus.TODO,
    },
    [processStepEnum.BOOKING_CONFIRMATION]: {
      iconHash: 'progress-landlord-pre-approval',
      status: processStatus.TODO,
    },
    [processStepEnum.RESELECTING_PAYMENT_PLAN]: {
      iconHash: 'reselect-payment-plan',
      status: processStatus.TODO,
    },
    [processStepEnum.PENDING_PAYMENT]: {
      iconHash: 'progress-deposit-payment',
      status: processStatus.TODO,
    },
    [processStepEnum.MOVE_IN]: {
      iconHash: 'longtail-process-check-in',
      status: processStatus.TODO,
    },
    [processStepEnum.COMPLETED]: {
      iconHash: 'progress-booking-complete',
      status: processStatus.TODO,
    },
  };

  if (!needReselectPaymentPlan) {
    delete processStep.reselecting_payment_plan;
  }

  processes?.map((process, index) => {
    switch (process.currentStage) {
      case orderStage.WAITING_FOR_CONFIRMATION:
        handleWaitingForConfirmation(process, processStep, processes);
        break;
      case orderStage.WAITING_FOR_PAYMENT:
        handleWaitingForPayment(
          process,
          processStep,
          processes,
          needReselectPaymentPlan,
          index + 1,
          index - 1,
        );
        break;
      case orderStage.WAITING_FOR_CHECK_IN:
        handleWaitingForCheckIn(
          process,
          processStep,
          processes,
          index + 1,
          index - 1,
          {
            updatedAt: order.paidAt,
            modifierName: `${order?.student?.passportFirstName} ${order?.student?.passportLastName}`,
          },
          order.landlordConfirmedPayment,
          noInstalmentType,
        );
        break;
      case orderStage.CHECKED_IN:
        handleCheckedIn(process, processStep, processes, index + 1);
        break;
      case orderStage.COMPLETED:
        handleCompleted(process, processStep);
        break;
    }
  });

  return {
    milestoneDetails: processStep,
    milestoneStatus: processStatus,
  };
};

export default formatProcessStep;
